(function () {
	const hasMapbox = typeof mapboxgl !== 'undefined';
	if (hasMapbox) {
		mapboxgl.accessToken = window.MAPBOX_ACCESS_TOKEN;
	}

	let allSchools = [];
	let map = null;
	let hoveredSchoolId = null;
	let filterByMapBounds = false;
	let isMapTriggeredFilter = false;
	let currentSearchQuery = '';
	let currentSortField = null;
	let currentSortDirection = null;
	let mySchoolIds = [];
	const mySchoolsCookieName = 'mySchoolIDs';
	const mySchoolsPageUrl = window.MY_SCHOOLS_PAGE_URL;

	// Filter state
	let selectedSchoolTypes = [];
	let selectedRegions = [];
	let selectedGrades = [];
	let selectedOffers = [];
	let selectedOtherInfo = [];
	let selectedSchoolYear = '';
	let selectedGender = '';
	let includeWaitlist = false;
	let activeDropdown = null;
	let otherInfoOptions = [];
	let regionOptions = [];
	let availableYears = [];

	const schoolTypeColors = {
		'Almen': '#001464',
		'Ordblinde': '#FF6B35',
		'Special': '#4CAF50'
	};

	function initMap() {
		if (typeof mapboxgl === 'undefined') {
			console.error('Mapbox GL JS not loaded - cannot initialize map');
			return;
		}

		map = new mapboxgl.Map({
			container: 'map',
			style: 'mapbox://styles/mapbox/streets-v12',
			center: [10.5, 56.2639],
			zoom: 6.5
		});

		map.on('load', () => {
			addMapLayers();
			loadSchools();
		});

		map.on('moveend', () => {
			if (filterByMapBounds) {
				isMapTriggeredFilter = true;
				applyFilters();
				isMapTriggeredFilter = false;
			}
		});

		map.on('zoomend', () => {
			if (filterByMapBounds) {
				isMapTriggeredFilter = true;
				applyFilters();
				isMapTriggeredFilter = false;
			}
		});
	}

	function renderSchoolYearRadios() {
		const desktopContainer = document.getElementById('schoolyearRadiosDesktop');
		const mobileContainer = document.getElementById('schoolyearRadiosMobile');

		if (!desktopContainer || !mobileContainer) return;

		desktopContainer.innerHTML = '';
		mobileContainer.innerHTML = '';

		availableYears.forEach(year => {
			const desktopRadio = `
				<label class="filter-option">
					<input type="radio" name="schoolyear" value="${year.Name}" class="schoolyear-radio">
					<span class="radiomark"></span>
					<span>${year.Name}</span>
				</label>
			`;

			const mobileRadio = `
				<label class="filter-option">
					<input type="radio" name="mobile-schoolyear" value="${year.Name}" class="mobile-schoolyear-radio">
					<span class="radiomark"></span>
					<span>${year.Name}</span>
				</label>
			`;

			desktopContainer.insertAdjacentHTML('beforeend', desktopRadio);
			mobileContainer.insertAdjacentHTML('beforeend', mobileRadio);
		});

		attachSchoolYearListeners();
	}

	function attachSchoolYearListeners() {
		document.querySelectorAll('.schoolyear-radio').forEach(radio => {
			radio.addEventListener('change', (e) => {
				selectedSchoolYear = e.target.value;
				syncDesktopToMobile();
				renderFilterTags();
				updateFilterCounts();
				applyFilters();
			});
		});

		document.querySelectorAll('.mobile-schoolyear-radio').forEach(radio => {
			radio.addEventListener('change', (e) => {
				selectedSchoolYear = e.target.value;
				syncMobileToDesktop();
				renderFilterTags();
				updateFilterCounts();
			});
		});
	}

	function addMapLayers() {
		map.addSource('schools', {
			type: 'geojson',
			data: {
				type: 'FeatureCollection',
				features: []
			},
			cluster: true,
			clusterMaxZoom: 14,
			clusterRadius: 50
		});

		map.addLayer({
			id: 'clusters',
			type: 'circle',
			source: 'schools',
			filter: ['has', 'point_count'],
			paint: {
				'circle-color': [
					'step',
					['get', 'point_count'],
					'#001464',
					10,
					'#11b4da',
					30,
					'#f1f075'
				],
				'circle-radius': [
					'step',
					['get', 'point_count'],
					20,
					10,
					30,
					30,
					40
				]
			}
		});

		map.addLayer({
			id: 'cluster-count',
			type: 'symbol',
			source: 'schools',
			filter: ['has', 'point_count'],
			layout: {
				'text-field': ['get', 'point_count_abbreviated'],
				'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
				'text-size': 12
			},
			paint: {
				'text-color': '#ffffff'
			}
		});

		map.addLayer({
			id: 'unclustered-point',
			type: 'circle',
			source: 'schools',
			filter: ['!', ['has', 'point_count']],
			paint: {
				'circle-color': ['get', 'markerColor'],
				'circle-radius': 10,
				'circle-stroke-width': 2,
				'circle-stroke-color': '#fff'
			}
		});

		map.on('click', 'clusters', (e) => {
			const features = map.queryRenderedFeatures(e.point, {
				layers: ['clusters']
			});
			const clusterId = features[0].properties.cluster_id;
			map.getSource('schools').getClusterExpansionZoom(
				clusterId,
				(err, zoom) => {
					if (err) return;
					map.easeTo({
						center: features[0].geometry.coordinates,
						zoom: zoom
					});
				}
			);
		});

		map.on('click', 'unclustered-point', (e) => {
			const schoolId = e.features[0].properties.id;
			if (schoolId) {
				const card = document.querySelector(`li[data-school-id="${schoolId}"]`);
				if (card) {
					card.scrollIntoView({ behavior: 'smooth', block: 'center' });
					highlightSchoolCard(schoolId);
					setTimeout(() => unhighlightSchoolCard(schoolId), 2000);
				}
			}
		});

		map.on('mouseenter', 'clusters', () => {
			map.getCanvas().style.cursor = 'pointer';
		});

		map.on('mouseleave', 'clusters', () => {
			map.getCanvas().style.cursor = '';
		});

		map.on('mouseenter', 'unclustered-point', (e) => {
			map.getCanvas().style.cursor = 'pointer';
			const schoolName = e.features[0].properties.name;

			new mapboxgl.Popup({
				closeButton: false,
				closeOnClick: false,
				offset: 15
			})
				.setLngLat(e.features[0].geometry.coordinates)
				.setHTML(`<div style="padding: 5px;"><h4 style="margin: 0; font-size: 14px; font-weight: 600;">${escapeHtml(schoolName)}</h4></div>`)
				.addTo(map);
		});

		map.on('mouseleave', 'unclustered-point', (e) => {
			map.getCanvas().style.cursor = '';
			const popup = document.querySelector('.mapboxgl-popup');
			if (popup) popup.remove();
		});
	}

	function parseUrlParameters() {
		const urlParams = new URLSearchParams(window.location.search);

		const q = urlParams.get('q');
		if (q) {
			currentSearchQuery = q;
			const searchInput = document.getElementById('searchInput') || document.getElementById('school-search-input');
			if (searchInput) searchInput.value = q;
		}

		const schooltype = urlParams.get('schooltype');
		if (schooltype) {
			selectedSchoolTypes = schooltype.split('|').filter(t => t);
		}

		const region = urlParams.get('region');
		if (region) {
			selectedRegions = region.split('|').filter(r => r);
		}

		const grade = urlParams.get('grade');
		if (grade) {
			selectedGrades = grade.split('|').filter(g => g);
		}

		const otherinfo = urlParams.get('otherinfo');
		if (otherinfo) {
			selectedOtherInfo = otherinfo.split('|').map(id => parseInt(id, 10)).filter(id => !isNaN(id));
		}

		const year = urlParams.get('year');
		if (year) {
			selectedSchoolYear = year;
		}

		const gender = urlParams.get('gender');
		if (gender) {
			selectedGender = gender;
		}

		const waitlist = urlParams.get('waitlist');
		if (waitlist === 'true') {
			includeWaitlist = true;
		}

		const educational = urlParams.get('educational');
		if (educational) {
			selectedOffers = educational.split('|').map(id => parseInt(id, 10)).filter(id => !isNaN(id));
		}

		const sortfield = urlParams.get('sortfield');
		if (sortfield) {
			const sortdirection = urlParams.get('sortdirection');
			handleSort(sortfield, sortdirection);
		}
	}

	function buildQueryString() {
		const params = new URLSearchParams();

		if (currentSearchQuery) {
			params.set('q', currentSearchQuery);
		}

		if (selectedSchoolTypes.length > 0) {
			params.set('schooltype', selectedSchoolTypes.join('|'));
		}

		if (selectedRegions.length > 0) {
			params.set('region', selectedRegions.join('|'));
		}

		if (selectedGrades.length > 0) {
			params.set('grade', selectedGrades.join('|'));
		}

		if (selectedOtherInfo.length > 0) {
			params.set('otherinfo', selectedOtherInfo.join('|'));
		}

		if (selectedSchoolYear) {
			params.set('year', selectedSchoolYear);
		}

		if (selectedGender) {
			params.set('gender', selectedGender);
		}

		if (includeWaitlist) {
			params.set('waitlist', 'true');
		}

		if (selectedOffers.length > 0) {
			params.set('educational', selectedOffers.join('|'));
		}

		return params.toString();
	}

	function updateUrlParameters() {
		const queryString = buildQueryString();
		const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
		window.history.replaceState({}, '', newUrl);
	}

	function preselectFiltersFromUrl() {
		document.querySelectorAll('.schooltype-checkbox').forEach(cb => {
			cb.checked = selectedSchoolTypes.includes(cb.value);
		});
		document.querySelectorAll('.mobile-schooltype-checkbox').forEach(cb => {
			cb.checked = selectedSchoolTypes.includes(cb.value);
		});

		document.querySelectorAll('.region-checkbox').forEach(cb => {
			cb.checked = selectedRegions.includes(cb.value);
		});
		document.querySelectorAll('.mobile-region-checkbox').forEach(cb => {
			cb.checked = selectedRegions.includes(cb.value);
		});

		document.querySelectorAll('.grade-checkbox').forEach(cb => {
			cb.checked = selectedGrades.includes(cb.value);
		});
		document.querySelectorAll('.mobile-grade-checkbox').forEach(cb => {
			cb.checked = selectedGrades.includes(cb.value);
		});

		document.querySelectorAll('.otherinfo-checkbox').forEach(cb => {
			const serviceId = parseInt(cb.value, 10);
			cb.checked = selectedOtherInfo.includes(serviceId);
		});
		document.querySelectorAll('.mobile-otherinfo-checkbox').forEach(cb => {
			const serviceId = parseInt(cb.value, 10);
			cb.checked = selectedOtherInfo.includes(serviceId);
		});

		document.querySelectorAll('.schoolyear-radio').forEach(rb => {
			rb.checked = rb.value === selectedSchoolYear || (!selectedSchoolYear && rb.value === '');
		});
		document.querySelectorAll('.mobile-schoolyear-radio').forEach(rb => {
			rb.checked = rb.value === selectedSchoolYear || (!selectedSchoolYear && rb.value === '');
		});

		document.querySelectorAll('.gender-radio').forEach(rb => {
			rb.checked = rb.value === selectedGender || (!selectedGender && rb.value === '');
		});
		document.querySelectorAll('.mobile-gender-radio').forEach(rb => {
			rb.checked = rb.value === selectedGender || (!selectedGender && rb.value === '');
		});

		document.querySelectorAll('.waitlist-checkbox').forEach(cb => {
			cb.checked = includeWaitlist;
		});
		document.querySelectorAll('.mobile-waitlist-checkbox').forEach(cb => {
			cb.checked = includeWaitlist;
		});

		renderFilterTags();
		updateFilterCounts();
	}

	async function loadSchools() {
		try {
			loadMySchoolsFromCookie();
			parseUrlParameters();
			const ts = Date.now();
			const [schoolsResponse, optionsResponse] = await Promise.all([
				fetch(`/searchschool?t=${ts}`),
				fetch(`/searchschooloptions?t=${ts}`)
			]);

			const schoolsData = await schoolsResponse.json();
			const optionsData = await optionsResponse.json();

			if (schoolsData.statusCode === "200" && schoolsData.Data && schoolsData.Data.Results) {
				allSchools = schoolsData.Data.Results;
				updateMapData(allSchools);
			}

			if (optionsData.statusCode === "200" && optionsData.Data) {
				if (optionsData.Data.otherInfo) {
					otherInfoOptions = optionsData.Data.otherInfo;
					renderOtherInfoCheckboxes();
				}
				if (optionsData.Data.schoolRegions) {
					regionOptions = optionsData.Data.schoolRegions;
					renderRegionCheckboxes();
				}
				if (optionsData.Data.AvailablePlacesYear) {
					availableYears = optionsData.Data.AvailablePlacesYear
						.filter(year => year.IncludeInSearch === true);
					renderSchoolYearRadios();
				}
			}

			preselectFiltersFromUrl();
			applyFilters();
		} catch (error) {
			console.error('Failed to load schools:', error);
			updateResultsCount(0);
		}
	}

	function renderRegionCheckboxes() {
		const desktopContainer = document.getElementById('regionCheckboxesDesktop');
		const mobileContainer = document.getElementById('regionCheckboxesMobile');

		if (!desktopContainer || !mobileContainer) return;

		desktopContainer.innerHTML = '';
		mobileContainer.innerHTML = '';

		regionOptions.forEach(option => {
			const desktopCheckbox = `
				<label class="filter-option">
					<input type="checkbox" value="${option.Name}" class="region-checkbox">
					<span class="checkmark"></span>
					<span>${option.Name}</span>
				</label>
			`;

			const mobileCheckbox = `
				<label class="filter-option">
					<input type="checkbox" value="${option.Name}" class="mobile-region-checkbox">
					<span class="checkmark"></span>
					<span>${option.Name}</span>
				</label>
			`;

			desktopContainer.innerHTML += desktopCheckbox;
			mobileContainer.innerHTML += mobileCheckbox;
		});

		attachRegionEventListeners();
	}

	function attachRegionEventListeners() {
		document.querySelectorAll('.region-checkbox').forEach(checkbox => {
			checkbox.addEventListener('change', (e) => {
				if (e.target.checked) {
					selectedRegions.push(e.target.value);
				} else {
					selectedRegions = selectedRegions.filter(r => r !== e.target.value);
				}
				syncDesktopToMobile();
				renderFilterTags();
				updateFilterCounts();
				applyFilters();
			});
		});

		document.querySelectorAll('.mobile-region-checkbox').forEach(checkbox => {
			checkbox.addEventListener('change', (e) => {
				if (e.target.checked) {
					selectedRegions.push(e.target.value);
				} else {
					selectedRegions = selectedRegions.filter(r => r !== e.target.value);
				}
				syncMobileToDesktop();
				renderFilterTags();
				updateFilterCounts();
			});
		});
	}

	// checkboxes with info boxes
	function renderCheckboxHtml(option, checkboxClass) {
		const hasInfo = option.Name && option.InfoText;

		return `
			<div class="filter-option-with-info">

				<label class="filter-option">
					<input type="checkbox" value="${option.Id}" class="${checkboxClass}">
					<span class="checkmark"></span>
					<span>${option.Name}</span>
				</label>

				${hasInfo ? `
					<div class="info-box-wrap">
						<button type="button" class="open-btn" data-info-id="info-${option.Id}">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
								viewBox="0 0 24 24" fill="none">
								<path
									d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
									stroke="#001564" stroke-width="2" stroke-linecap="round"
									stroke-linejoin="round" />
						</svg>
					</button>

					<div id="info-${option.Id}" class="information-box">
						<button type="button" class="close-btn">
							<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19"
								viewBox="0 0 19 19" fill="none">
								<path
									d="M11.8333 6.83333L6.83333 11.8333M6.83333 6.83333L11.8333 11.8333M17.6667 9.33333C17.6667 13.9357 13.9357 17.6667 9.33333 17.6667C4.73096 17.6667 1 13.9357 1 9.33333C1 4.73096 4.73096 1 9.33333 1C13.9357 1 17.6667 4.73096 17.6667 9.33333Z"
									stroke="#1D52F3" stroke-width="2" stroke-linecap="round"
									stroke-linejoin="round" />
							</svg>
						</button>
						<p class="style-h4">${option.Name}</p>
						<p>${option.InfoText}</p>
					</div>
					</div>
				` : ""}

			</div>
		`;
	}

	function renderOtherInfoCheckboxes() {
		const desktopContainer = document.getElementById('otherInfoCheckboxesDesktop');
		const mobileContainer = document.getElementById('otherInfoCheckboxesMobile');

		if (!desktopContainer || !mobileContainer) return;

		desktopContainer.innerHTML = '';
		mobileContainer.innerHTML = '';

		otherInfoOptions.forEach(option => {
			const desktopCheckbox = renderCheckboxHtml(option, "otherinfo-checkbox");
			const mobileCheckbox = renderCheckboxHtml(option, "mobile-otherinfo-checkbox");

			desktopContainer.innerHTML += desktopCheckbox;
			mobileContainer.innerHTML += mobileCheckbox;
		});

		attachOtherInfoEventListeners();
	}

	function attachOtherInfoEventListeners() {
		document.querySelectorAll('.otherinfo-checkbox').forEach(checkbox => {
			checkbox.addEventListener('change', (e) => {
				const serviceId = parseInt(e.target.value, 10);
				if (e.target.checked) {
					if (!selectedOtherInfo.includes(serviceId)) {
						selectedOtherInfo.push(serviceId);
					}
				} else {
					selectedOtherInfo = selectedOtherInfo.filter(id => id !== serviceId);
				}
				syncDesktopToMobile();
				renderFilterTags();
				updateFilterCounts();
				applyFilters();
			});
		});

		document.querySelectorAll('.mobile-otherinfo-checkbox').forEach(checkbox => {
			checkbox.addEventListener('change', (e) => {
				const serviceId = parseInt(e.target.value, 10);
				if (e.target.checked) {
					if (!selectedOtherInfo.includes(serviceId)) {
						selectedOtherInfo.push(serviceId);
					}
				} else {
					selectedOtherInfo = selectedOtherInfo.filter(id => id !== serviceId);
				}
				syncMobileToDesktop();
				renderFilterTags();
				updateFilterCounts();
			});
		});
	}

	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
		return null;
	}

	function setCookie(name, value, days = 365) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		const expires = `expires=${date.toUTCString()}`;
		document.cookie = `${name}=${value};${expires};path=/`;
	}

	function deleteCookie(name) {
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
	}

	function loadMySchoolsFromCookie() {
		const cookie = getCookie(mySchoolsCookieName);
		if (cookie) {
			try {
				mySchoolIds = JSON.parse(decodeURIComponent(cookie));
			} catch (e) {
				mySchoolIds = [];
			}
		}
	}

	function saveMySchoolsToCookie() {
		const value = encodeURIComponent(JSON.stringify(mySchoolIds));
		setCookie(mySchoolsCookieName, value);
	}

	function isMySchool(schoolId) {
		return mySchoolIds.includes(schoolId);
	}

	function toggleMySchool(schoolId, event) {
		event.preventDefault();
		event.stopPropagation();

		if (isMySchool(schoolId)) {
			mySchoolIds = mySchoolIds.filter(id => id !== schoolId);
		} else {
			mySchoolIds.push(schoolId);
		}

		saveMySchoolsToCookie();
		applyFilters();
	}

	function displaySchools(schools) {
		const sortedSchools = sortSchools(schools);
		renderSchoolCards(sortedSchools);
	}

	function sortSchools(schools) {
		if (!currentSortField || !currentSortDirection) {
			return schools;
		}

		const sorted = [...schools];
		sorted.sort((a, b) => {
			let aValue, bValue;

			switch (currentSortField) {
				case 'name':
					aValue = (a.Title || '').toLowerCase();
					bValue = (b.Title || '').toLowerCase();
					break;
				case 'price':
					const aHasPrice = /\d/.test(a.Price);
					const bHasPrice = /\d/.test(b.Price);

					if (!aHasPrice && !bHasPrice) break;
					if (!aHasPrice) return 1;
					if (!bHasPrice) return -1;

					aValue = parseInt(a.Price.replace(/\D/g, ''));
					bValue = parseInt(b.Price.replace(/\D/g, ''));
					break;
				case 'pupils':
					aValue = parseInt(a.Pupils) || 0;
					bValue = parseInt(b.Pupils) || 0;
					break;
				case 'region':
					aValue = (a.Region || '').toLowerCase();
					bValue = (b.Region || '').toLowerCase();
					break;
				default:
					return 0;
			}

			if (currentSortDirection === 'asc') {
				return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
			} else {
				return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
			}
		});

		return sorted;
	}

	function handleSort(field, sortdirection) {
		if (currentSortField === field) {
			if (currentSortDirection === 'asc') {
				currentSortDirection = 'desc';
			} else if (currentSortDirection === 'desc') {
				currentSortField = null;
				currentSortDirection = null;
			} else {
				currentSortDirection = 'asc';
			}
		} else {
			currentSortField = field;
			currentSortDirection = sortdirection || 'asc';
		}

		updateSortUI();
		applyFilters();
	}

	function updateSortUI() {
		document.querySelectorAll('.sort-bar a').forEach(link => {
			const field = link.dataset.field;
			const icon = link.querySelector('.icon-triangle');

			if (field === currentSortField) {
				if (currentSortDirection === 'asc') {
					icon.className = 'icon-triangle white down';
				} else {
					icon.className = 'icon-triangle white up';
				}
				link.dataset.direction = currentSortDirection;
			} else {
				icon.className = 'icon-triangle';
				link.dataset.direction = 'none';
			}
		});
	}

	function updateMapData(schools) {
		if (!map) {
			return;
		}

		const features = schools
			.filter(school => school.Location)
			.map(school => {
				const [lat, lng] = school.Location.split(';').map(parseFloat);
				if (isNaN(lat) || isNaN(lng)) return null;

				const schoolType = school.SchoolTypeContent || 'Unknown';
				let markerColor = '#666666';

				if (schoolType === 'Almen') {
					markerColor = '#001464';
				} else if (schoolType === 'Ordblinde' || schoolType.includes('Ordblinde')) {
					markerColor = '#FF6B35';
				} else if (schoolType === 'Special') {
					markerColor = '#4CAF50';
				}

				return {
					type: 'Feature',
					geometry: {
						type: 'Point',
						coordinates: [lng, lat]
					},
					properties: {
						id: school.Id,
						name: school.Title,
						url: school.ItemUrl,
						schoolType: schoolType,
						markerColor: markerColor
					}
				};
			})
			.filter(feature => feature !== null);

		const geojsonData = {
			type: 'FeatureCollection',
			features: features
		};

		if (map.getSource('schools')) {
			map.getSource('schools').setData(geojsonData);
		}
	}

	function renderSchoolCard(school, container) {
		const li = document.createElement('li');
		li.className = 'clearfix';
		if (school.ListImageUrl) li.classList.add('has-image');
		li.setAttribute('data-school-id', school.Id);

		const classesHtml = school.Classes && school.Classes.length > 0
			? school.Classes.join(', ')
			: '';

		const altText = school.ListImageUrl?.AltText?.trim()
			? escapeHtml(school.ListImageUrl.AltText)
			: "";

		const imageHtml = school.ListImageUrl
			? `<div class="img loaded"><img src="${school.ListImageUrl}?width=450&height=250" loading="lazy" alt="${altText}"></div>`
			: '';

		const isFavorite = isMySchool(school.Id);
		const favoriteClass = isFavorite ? 'added' : '';

		li.innerHTML = `<a href="${school.ItemUrl}" class="image-title clearfix">${imageHtml}<h3 class="style-h4">${escapeHtml(school.Title)}</h3></a><strong class="school-type" type="${school.SchoolTypeContent}">${school.SchoolTypeContent || ''}</strong>${getPriceLabel(school)}${getPriceCalculatorLink()}<ul class="meta"><li><strong>${school.Pupils || '0'}</strong> Elever</li>${school.Region ? `<li><strong>${escapeHtml(school.Region)}</strong></li>` : ''}${classesHtml ? `<li><strong>${classesHtml}</strong> Klasse</li>` : ''}</ul><p>${escapeHtml(school.Abstract || '')}</p><a href="${school.ItemUrl}" class="cta icon-right">L&#230;s mere</a><div class="cta icon-right favorite ${favoriteClass}" data-school-id="${school.Id}"><span>${isFavorite ? 'Fjern fra' : 'Tilf&#248;j til'}</span> <a href="${mySchoolsPageUrl || '#'}">mine skoler</a><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="22px" height="20px" viewBox="0 0 22 20" xml:space="preserve"><path stroke="" stroke-width="2" fill="" d="M19.5,3.2c-2-2-5.4-2-7.4,0L11,4.2l-0.7-0.7L9.9,3.2c-2-2-5.4-2-7.4,0c-2,2-2,5.2,0,7.2l8.5,8.3l8.5-8.3C21.5,8.3,21.5,5.1,19.5,3.2z M19.5,3.2C19.5,3.2,19.5,3.2,19.5,3.2L19.5,3.2C19.5,3.2,19.5,3.2,19.5,3.2z" /></svg></div>`;
		const favoriteBtn = li.querySelector('.favorite');
		favoriteBtn.addEventListener('click', (e) => {
			if (e.target.tagName === 'A' || e.target.closest('a')) {
				return;
			}
			toggleMySchool(school.Id, e);
		});

		container.appendChild(li);
	}

	function renderSchoolCards(schools) {
		validatePriceCookie();
		const schoolsList = document.getElementById('schoolsList');
		if (!schoolsList) {
			return;
		}
		schoolsList.innerHTML = '';

		// Separate schools by availability status (only if waitlist filter is active)
		if (includeWaitlist && (selectedSchoolYear || selectedGender)) {
			const available = [];
			const waitlistOnly = [];

			schools.forEach(school => {
				const status = getSchoolAvailabilityStatus(school);
				if (status === 'available') {
					available.push(school);
				} else if (status === 'waitlist') {
					waitlistOnly.push(school);
				}
			});

			// Render available schools
			available.forEach(school => {
				renderSchoolCard(school, schoolsList);
			});

			// Render waitlist section if there are waitlist-only schools
			if (waitlistOnly.length > 0) {
				const header = document.createElement('li');
				header.className = 'waitlist-header';
				header.innerHTML = `
					<div class="info-box-wrap">
						<h4 class="style-h4">Venteliste</h4>
						<button type="button" class="open-btn">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
								viewBox="0 0 24 24" fill="none">
								<path
									d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
									stroke="currentColor" stroke-width="2" stroke-linecap="round"
									stroke-linejoin="round" />
							</svg>
						</button>
						<div class="information-box">
							<button type="button" class="close-btn">
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
									viewBox="0 0 20 20" fill="none">
									<g clip-path="url(#clip0_107_530)">
										<path
											d="M12.4998 7.49984L7.49984 12.4998M7.49984 7.49984L12.4998 12.4998M18.3332 9.99984C18.3332 14.6022 14.6022 18.3332 9.99984 18.3332C5.39746 18.3332 1.6665 14.6022 1.6665 9.99984C1.6665 5.39746 5.39746 1.6665 9.99984 1.6665C14.6022 1.6665 18.3332 5.39746 18.3332 9.99984Z"
											stroke="#1D52F3" stroke-width="2" stroke-linecap="round"
											stroke-linejoin="round" />
									</g>
									<defs>
										<clipPath id="clip0_107_530">
											<rect width="20" height="20" fill="white" />
										</clipPath>
									</defs>
								</svg>
							</button>
							<p class="style-h4">Venteliste</p>
							<p>De pågældende skoler er i øjeblikket fuldt optaget. Kontakt skolen, hvis du ønsker at blive skrevet på ventelisten</p>
						</div>
					</div>

				`;
				schoolsList.appendChild(header);

				waitlistOnly.forEach(school => {
					renderSchoolCard(school, schoolsList);
				});
			}
		} else {
			// No separation needed
			schools.forEach(school => {
				renderSchoolCard(school, schoolsList);
			});
		}
	}

	function validatePriceCookie() {
		var cookie = getCookie('school');
		if (cookie) {
			const data = JSON.parse(decodeURIComponent(cookie));
			if (data) {
				if (data.boxQuery.Year.includes('-')) {
					deleteCookie('school');
				}
			}
		}
	}

	function getPriceLabel(school) {
		var cookie = getCookie('school');
		if (cookie && school.Price) {
			return '<a class="price"><span>' + school.Price + '</span></a>';
		}

		return "";
	}

	function getPriceCalculatorLink() {
		var cookie = getCookie('school');
		if (!cookie) {
			return '<a class="price noPrice"><span>Beregn pris <i class="icon-kr"></i></span></a>';
		}

		return "";
	}

	function highlightSchoolCard(schoolId) {
		const card = document.querySelector(`li[data-school-id="${schoolId}"]`);
		if (card) {
			card.style.backgroundColor = '#f0f7ff';
			card.style.boxShadow = '0 0 0 2px #11b4da';
		}
	}

	function unhighlightSchoolCard(schoolId) {
		const card = document.querySelector(`li[data-school-id="${schoolId}"]`);
		if (card) {
			card.style.backgroundColor = '';
			card.style.boxShadow = '';
		}
	}

	function normalizeDanishText(text) {
		if (!text) return '';
		return text.toLowerCase().replace(/å/g, 'aa');
	}

	function filterSchools(query) {
		currentSearchQuery = query;
		applyFilters();
	}

	function applyFilters() {
		const filtered = getFilteredSchools();
		displaySchools(filtered);
		updateResultsCount(filtered.length);
		updateFilterCounts();
		updateMapData(filtered);
		if (!isMapTriggeredFilter) {
			autoZoomToFilteredSchools(filtered);
		}
		updateUrlParameters();
	}

	function isSchoolInBounds(school) {
		if (!school.Location || !map) return false;

		try {
			const [lat, lng] = school.Location.split(';').map(parseFloat);
			if (isNaN(lat) || isNaN(lng)) return false;

			const bounds = map.getBounds();
			return bounds.contains([lng, lat]);
		} catch (error) {
			console.error('Error checking bounds:', error);
			return false;
		}
	}

	function autoZoomToFilteredSchools(schools) {
		if (!map || schools.length === 0) return;

		const bounds = new mapboxgl.LngLatBounds();
		let hasValidLocation = false;

		schools.forEach(school => {
			if (school.Location) {
				const [lat, lng] = school.Location.split(';').map(parseFloat);
				if (!isNaN(lat) && !isNaN(lng)) {
					bounds.extend([lng, lat]);
					hasValidLocation = true;
				}
			}
		});

		if (hasValidLocation) {
			map.fitBounds(bounds, { padding: 50, maxZoom: 15 });
		}
	}

	function updateResultsCount(count) {
		const resultsCount = document.getElementById('resultsCount');
		if (!resultsCount) {
			return;
		}
		if (count === 0) {
			resultsCount.textContent = 'Ingen skoler matcher din søgning';
		} else {
			resultsCount.textContent = `Viser ${count} ${count === 1 ? 'skole' : 'skoler'}`;
		}
	}

	function escapeHtml(text) {
		if (!text) return '';
		const div = document.createElement('div');
		div.textContent = text;
		return div.innerHTML;
	}

	function toggleDropdown(dropdownId, btnId) {
		const dropdown = document.getElementById(dropdownId);
		const btn = document.getElementById(btnId);

		if (activeDropdown && activeDropdown !== dropdownId) {
			document.getElementById(activeDropdown).classList.remove('active');
			document.querySelector(`#${activeDropdown.replace('Dropdown', 'Btn')}`).classList.remove('active');
		}

		dropdown.classList.toggle('active');
		btn.classList.toggle('active');
		activeDropdown = dropdown.classList.contains('active') ? dropdownId : null;
	}

	function syncDesktopToMobile() {
		document.querySelectorAll('.mobile-schooltype-checkbox').forEach(cb => {
			cb.checked = selectedSchoolTypes.includes(cb.value);
		});
		document.querySelectorAll('.mobile-region-checkbox').forEach(cb => {
			cb.checked = selectedRegions.includes(cb.value);
		});
		document.querySelectorAll('.grade-checkbox').forEach(cb => {
			cb.checked = selectedGrades.includes(cb.value);
		});
		document.querySelectorAll('.mobile-grade-checkbox').forEach(cb => {
			cb.checked = selectedGrades.includes(cb.value);
		});
		document.querySelectorAll('.mobile-schoolyear-radio').forEach(rb => {
			rb.checked = rb.value === selectedSchoolYear;
		});
		document.querySelectorAll('.mobile-gender-radio').forEach(rb => {
			rb.checked = rb.value === selectedGender;
		});
		document.querySelectorAll('.mobile-waitlist-checkbox').forEach(cb => {
			cb.checked = includeWaitlist;
		});
		document.querySelectorAll('.mobile-otherinfo-checkbox').forEach(cb => {
			const serviceId = parseInt(cb.value, 10);
			cb.checked = selectedOtherInfo.includes(serviceId);
		});
	}

	function syncMobileToDesktop() {
		document.querySelectorAll('.schooltype-checkbox').forEach(cb => {
			cb.checked = selectedSchoolTypes.includes(cb.value);
		});
		document.querySelectorAll('.region-checkbox').forEach(cb => {
			cb.checked = selectedRegions.includes(cb.value);
		});
		document.querySelectorAll('.grade-checkbox').forEach(cb => {
			cb.checked = selectedGrades.includes(cb.value);
		});
		document.querySelectorAll('.schoolyear-radio').forEach(rb => {
			rb.checked = rb.value === selectedSchoolYear;
		});
		document.querySelectorAll('.gender-radio').forEach(rb => {
			rb.checked = rb.value === selectedGender;
		});
		document.querySelectorAll('.waitlist-checkbox').forEach(cb => {
			cb.checked = includeWaitlist;
		});
		document.querySelectorAll('.otherinfo-checkbox').forEach(cb => {
			const serviceId = parseInt(cb.value, 10);
			cb.checked = selectedOtherInfo.includes(serviceId);
		});
	}

	function updateFilterCounts() {
		const totalFilters = selectedSchoolTypes.length + selectedRegions.length + selectedGrades.length + selectedOtherInfo.length +
			(selectedSchoolYear ? 1 : 0) + (selectedGender ? 1 : 0) + (includeWaitlist ? 1 : 0);

		const mobileFilterCount = document.getElementById('mobileFilterCount');
		if (mobileFilterCount) {
			mobileFilterCount.textContent = totalFilters;
		}

		const filtered = getFilteredSchools();
		const schoolsCount = document.getElementById('schoolsCount');
		if (schoolsCount) {
			schoolsCount.textContent = filtered.length;
		}
		const flereFilterCount = document.getElementById('flereFilterCount');
		if (flereFilterCount) {
			flereFilterCount.textContent = filtered.length;
		}
		const mobileApplyCount = document.getElementById('mobileApplyCount');
		if (mobileApplyCount) {
			mobileApplyCount.textContent = filtered.length;
		}

		// Update school-count link (used in component status bar)
		const schoolCountLink = document.getElementById('school-count');
		if (schoolCountLink) {
			const parentStrong = schoolCountLink.closest('strong.viewing');
			const noResultsStrong = document.querySelector('strong.no-results');

			if (filtered.length === 0) {
				schoolCountLink.textContent = 'Vis skoler';
				if (parentStrong) parentStrong.style.display = 'none';
				if (noResultsStrong) noResultsStrong.style.display = 'inline';
			} else {
				schoolCountLink.textContent = `Vis ${filtered.length} ${filtered.length === 1 ? 'skole' : 'skoler'}`;
				if (parentStrong) parentStrong.style.display = 'inline';
				if (noResultsStrong) noResultsStrong.style.display = 'none';
			}
		}
	}

	function renderFilterTags() {
		const container = document.getElementById('filterTagsContainer');
		const row = document.getElementById('filterTagsRow');

		if (!container || !row) {
			return;
		}

		container.innerHTML = '';

		const tags = [];
		selectedSchoolTypes.forEach(type => {
			tags.push({ type: 'schoolType', value: type, label: `Skoletype: ${type}` });
		});
		selectedRegions.forEach(region => {
			tags.push({ type: 'region', value: region, label: `Landsdel: ${region}` });
		});
		selectedGrades.forEach(grade => {
			tags.push({ type: 'grade', value: grade, label: `Årgang: ${grade}.` });
		});
		selectedOtherInfo.forEach(serviceId => {
			const option = otherInfoOptions.find(o => o.Id === serviceId);
			if (option) {
				tags.push({ type: 'otherInfo', value: serviceId, label: option.Name });
			}
		});
		selectedOffers.forEach(offerId => {
			let offerName = '';

			for (const school of allSchools) {
				if (school.Offers && Array.isArray(school.Offers)) {
					const offer = school.Offers.find(o => o.id === offerId);
					if (offer) {
						offerName = offer.name;
						break;
					}
				}
			}

			tags.push({
				type: 'offer',
				value: offerId,
				label: `${offerName}`
			});
		});
		if (selectedSchoolYear) {
			tags.push({ type: 'schoolYear', value: selectedSchoolYear, label: `Skoleår: ${selectedSchoolYear}` });
		}
		if (selectedGender) {
			tags.push({ type: 'gender', value: selectedGender, label: `Køn: ${selectedGender}` });
		}
		if (includeWaitlist) {
			tags.push({ type: 'waitlist', value: 'true', label: `Inkl. venteliste` });
		}

		if (tags.length > 0) {
			row.style.display = 'flex';
			tags.forEach(tag => {
				const tagEl = document.createElement('div');
				tagEl.className = 'filter-tag';
				tagEl.innerHTML = `${tag.label} <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
													<path d="M10.75 0.75L0.75 10.75M0.75 0.75L10.75 10.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>`;
				tagEl.addEventListener('click', () => removeFilter(tag.type, tag.value));
				container.appendChild(tagEl);
			});
		} else {
			row.style.display = 'none';
		}
	}

	function removeFilter(type, value) {
		if (type === 'schoolType') {
			selectedSchoolTypes = selectedSchoolTypes.filter(t => t !== value);
		} else if (type === 'region') {
			selectedRegions = selectedRegions.filter(r => r !== value);
		} else if (type === 'grade') {
			selectedGrades = selectedGrades.filter(g => g !== value);
		} else if (type === 'otherInfo') {
			selectedOtherInfo = selectedOtherInfo.filter(id => id !== value);
			document.querySelectorAll('.otherinfo-checkbox, .mobile-otherinfo-checkbox').forEach(cb => {
				if (parseInt(cb.value, 10) === value) cb.checked = false;
			});
		} else if (type === 'schoolYear') {
			selectedSchoolYear = '';
			document.querySelectorAll('.schoolyear-radio[value=""], .mobile-schoolyear-radio[value=""]').forEach(rb => rb.checked = true);
		} else if (type === 'offer') {
			const id = parseInt(value, 10);
			selectedOffers = selectedOffers.filter(o => o !== id);
		} else if (type === 'gender') {
			selectedGender = '';
			document.querySelectorAll('.gender-radio[value=""], .mobile-gender-radio[value=""]').forEach(rb => rb.checked = true);
		} else if (type === 'waitlist') {
			includeWaitlist = false;
			document.querySelectorAll('.waitlist-checkbox, .mobile-waitlist-checkbox').forEach(cb => cb.checked = false);
		}

		syncDesktopToMobile();
		syncMobileToDesktop();
		renderFilterTags();
		updateFilterCounts();
		applyFilters();
	}

	function clearAllFilters() {
		selectedSchoolTypes = [];
		selectedRegions = [];
		selectedGrades = [];
		selectedOffers = [];
		selectedOtherInfo = [];
		selectedSchoolYear = '';
		selectedGender = '';
		includeWaitlist = false;
		currentSearchQuery = '';

		const searchInput = document.getElementById('searchInput') || document.getElementById('school-search-input');
		if (searchInput) searchInput.value = '';

		document.querySelectorAll('.schooltype-checkbox, .mobile-schooltype-checkbox').forEach(cb => cb.checked = false);
		document.querySelectorAll('.region-checkbox, .mobile-region-checkbox').forEach(cb => cb.checked = false);
		document.querySelectorAll('.grade-checkbox, .mobile-grade-checkbox').forEach(cb => cb.checked = false);
		document.querySelectorAll('.schoolyear-radio[value=""], .mobile-schoolyear-radio[value=""]').forEach(rb => rb.checked = true);
		document.querySelectorAll('.gender-radio[value=""], .mobile-gender-radio[value=""]').forEach(rb => rb.checked = true);
		document.querySelectorAll('.waitlist-checkbox, .mobile-waitlist-checkbox').forEach(cb => cb.checked = false);
		document.querySelectorAll('.otherinfo-checkbox, .mobile-otherinfo-checkbox').forEach(cb => cb.checked = false);

		renderFilterTags();
		updateFilterCounts();
		applyFilters();
	}

	function getFilteredSchools() {
		let filtered = [...allSchools];

		if (currentSearchQuery) {
			const normalizedQuery = normalizeDanishText(currentSearchQuery);
			filtered = filtered.filter(school =>
				school.Title && normalizeDanishText(school.Title).includes(normalizedQuery)
			);
		}

		if (selectedSchoolTypes.length > 0) {
			filtered = filtered.filter(school =>
				selectedSchoolTypes.includes(school.SchoolTypeContent)
			);
		}

		if (selectedRegions.length > 0) {
			filtered = filtered.filter(school =>
				selectedRegions.includes(school.Region)
			);
		}

	if (selectedGrades.length > 0) {
		filtered = filtered.filter(school => {
			if (!school.Classes || !Array.isArray(school.Classes)) return false;
			return selectedGrades.every(grade => school.Classes.includes(grade));
		});
	}

	if (selectedOffers.length > 0) {
		filtered = filtered.filter(school => {
			if (!school.Offers || !Array.isArray(school.Offers)) return false;
			return selectedOffers.every(offerId =>
				school.Offers.some(offer => offer.id === offerId)
			);
		});
	}

		if (selectedOtherInfo.length > 0) {
			filtered = filtered.filter(school => {
				if (!school.ExtraServices || !Array.isArray(school.ExtraServices)) return false;
				return selectedOtherInfo.every(serviceId =>
					school.ExtraServices.some(service => service.id === serviceId)
				);
			});
		}

	function isAvailableWithoutLines(school) {
		if (selectedGrades.length === 0) {
			return true;
		}

		const schoolClasses = Array.isArray(school.Classes) ? school.Classes : [];
		const schoolYears = Array.isArray(school.Years)
			? school.Years.map(year => year && year.name ? year.name : year).filter(Boolean)
			: [];

		return selectedGrades.every(grade =>
			schoolClasses.includes(grade) || schoolYears.includes(grade)
		);
	}

	// Only filter by availability if grades or gender are selected
	if (selectedGrades.length > 0 || selectedGender) {
		filtered = filtered.filter(school => {
			if (!Array.isArray(school.Lines) || school.Lines.length === 0) {
				return isAvailableWithoutLines(school);
			}

			let hasMatchingYear = false;
			let hasAvailabilityMatch = false;

			for (const line of school.Lines) {
				if (!line.years || !Array.isArray(line.years)) continue;

				for (const year of line.years) {
					if (selectedSchoolYear && year.yearName !== selectedSchoolYear) continue;

					hasMatchingYear = true;

					if (!year.grades || !Array.isArray(year.grades)) continue;

				for (const grade of year.grades) {
					// Skip grades that don't match selectedGrades (if any are selected)
					if (selectedGrades.length > 0 && !selectedGrades.includes(grade.gradeName)) {
						continue;
					}

					let hasAvailability = false;

					if (selectedGender === 'Dreng') {
						const status = grade.boysStatus;
						if (status === 'Ledig') {
							hasAvailability = true;
						} else if (includeWaitlist && status === 'Venteliste') {
							hasAvailability = true;
						}
					} else if (selectedGender === 'Pige') {
						const status = grade.girlsStatus;
						if (status === 'Ledig') {
							hasAvailability = true;
						} else if (includeWaitlist && status === 'Venteliste') {
							hasAvailability = true;
						}
					} else if (!selectedGender) {
						const girlStatus = grade.girlsStatus;
						const boyStatus = grade.boysStatus;
						if (girlStatus === 'Ledig' || boyStatus === 'Ledig') {
							hasAvailability = true;
						} else if (includeWaitlist && (girlStatus === 'Venteliste' || boyStatus === 'Venteliste')) {
							hasAvailability = true;
						}
					}

					if (hasAvailability) {
						hasAvailabilityMatch = true;
						return true;
					}
				}
				}
			}

			// If school has Lines but no data for selected year, still show it
			if (selectedSchoolYear && !hasMatchingYear) {
				return true;
			}

			return hasAvailabilityMatch;
		});
	}

		if (filterByMapBounds && map) {
			filtered = filtered.filter(school => isSchoolInBounds(school));
		}

		return filtered;
	}

	function getSchoolAvailabilityStatus(school) {
		if (!Array.isArray(school.Lines) || school.Lines.length === 0) {
			const schoolClasses = Array.isArray(school.Classes) ? school.Classes : [];
			const schoolYears = Array.isArray(school.Years)
				? school.Years.map(year => year && year.name ? year.name : year).filter(Boolean)
				: [];

			if (selectedGrades.length > 0) {
				const supportsSelectedGrades = selectedGrades.every(grade =>
					schoolClasses.includes(grade) || schoolYears.includes(grade)
				);

				if (!supportsSelectedGrades) {
					return 'none';
				}
			}

			return 'available';
		}

		let hasAvailable = false;
		let hasWaitlist = false;

		for (const line of school.Lines) {
			if (!line.years || !Array.isArray(line.years)) continue;

			for (const year of line.years) {
				// If filtering by year, only check that year
				if (selectedSchoolYear && year.yearName !== selectedSchoolYear) continue;

				if (!year.grades || !Array.isArray(year.grades)) continue;

				for (const grade of year.grades) {
					// If filtering by grade, only check selected grades
					if (selectedGrades.length > 0 && !selectedGrades.includes(grade.gradeName)) continue;

					// Check availability based on gender filter
					if (selectedGender === 'Dreng') {
						if (grade.boysStatus === 'Ledig') {
							hasAvailable = true;
						} else if (grade.boysStatus === 'Venteliste') {
							hasWaitlist = true;
						}
					} else if (selectedGender === 'Pige') {
						if (grade.girlsStatus === 'Ledig') {
							hasAvailable = true;
						} else if (grade.girlsStatus === 'Venteliste') {
							hasWaitlist = true;
						}
					} else {
						// No gender filter - check both
						if (grade.girlsStatus === 'Ledig' || grade.boysStatus === 'Ledig') {
							hasAvailable = true;
						}
						if (grade.girlsStatus === 'Venteliste' || grade.boysStatus === 'Venteliste') {
							hasWaitlist = true;
						}
					}
				}
			}
		}

		if (hasAvailable) {
			return 'available';
		} else if (hasWaitlist) {
			return 'waitlist';
		}
		return 'none';
	}

	function scrollToResults() {
		const resultsSection = document.querySelector('.search-results');
		if (resultsSection) {
			resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	function extractMatchingOffers(query) {
		if (!query) return [];

		const lowerQuery = query.toLowerCase();
		const offerMap = new Map();
		const selectedOfferIds = selectedOffers.map(id => id);

		allSchools.forEach(school => {
			if (school.Offers && Array.isArray(school.Offers)) {
				school.Offers.forEach(offer => {
					if (offer.name && offer.name.toLowerCase().includes(lowerQuery) && !selectedOfferIds.includes(offer.id)) {
						if (offerMap.has(offer.id)) {
							offerMap.get(offer.id).count++;
						} else {
							offerMap.set(offer.id, {
								id: offer.id,
								name: offer.name,
								count: 1
							});
						}
					}
				});
			}
		});

		return Array.from(offerMap.values()).sort((a, b) => b.count - a.count);
	}

	function renderSuggestions(filteredSchools, query) {
		const suggestionsContainer = document.querySelector('.search-box-wrap .suggestions');
		if (!suggestionsContainer) return;

		const matchingOffers = extractMatchingOffers(query);

		if ((!filteredSchools || filteredSchools.length === 0) && matchingOffers.length === 0) {
			hideSuggestions();
			return;
		}

		let html = '';

		if (matchingOffers.length > 0) {
			const offerItems = matchingOffers.map(offer =>
				`<li><a href="#" data-offer-id="${offer.id}" data-offer-name="${escapeHtml(offer.name)}" class="offer-filter-item">${escapeHtml(offer.name)} <small>${offer.count} skoler</small></a></li>`
			).join('');

			html += `
				<div class="group">
					<h3>Interesse filtre</h3>
					<ul>${offerItems}</ul>
				</div>
			`;
		}

		if (filteredSchools && filteredSchools.length > 0) {
			const schoolItems = filteredSchools.slice(0, 10).map(school =>
				`<li><a href="${school.ItemUrl}" class="cta icon-right">${escapeHtml(school.Title)}</a></li>`
			).join('');

			html += `
				<div class="group">
					<h3>skoler</h3>
					<ul>${schoolItems}</ul>
				</div>
			`;
		}

		suggestionsContainer.innerHTML = html;
		suggestionsContainer.style.display = 'block';
		suggestionsContainer.style.maxHeight = '400px';
		suggestionsContainer.style.overflow = 'auto';
	}

	function hideSuggestions() {
		const suggestionsContainer = document.querySelector('.search-box-wrap .suggestions');
		if (suggestionsContainer) {
			suggestionsContainer.style.display = 'none';
			suggestionsContainer.innerHTML = '';
		}
	}

	function addOfferTag(offerId, offerName) {
		if (selectedOffers.includes(offerId)) {
			return;
		}

		selectedOffers.push(offerId);
		const searchInput = document.getElementById('searchInput') || document.getElementById('school-search-input');
		if (searchInput) {
			searchInput.value = '';
		}
		currentSearchQuery = '';
		hideSuggestions();
		renderFilterTags();
		applyFilters();
	}

	function initPriceCalculatorModal() {
		const calcPriceLink = document.querySelector('.calc-price');
		const overlay = document.querySelector('.overlay');
		const closeBtn = document.querySelector('.overlay .icon-close.circle');

		if (calcPriceLink && overlay) {
			calcPriceLink.addEventListener('click', function (e) {
				e.preventDefault();
				overlay.style.display = 'block';
			});
		}

		if (closeBtn && overlay) {
			closeBtn.addEventListener('click', function () {
				overlay.style.display = 'none';
			});
		}

		if (overlay) {
			overlay.addEventListener('click', function (e) {
				if (e.target === overlay) {
					overlay.style.display = 'none';
				}
			});
		}

		document.addEventListener('submit', function (e) {
			if (e.target.closest('.module-price-calculator form')) {
				e.preventDefault();
				overlay.style.display = 'none';

				setTimeout(function () {
					const isComponentPage = !document.getElementById('schoolsList');
					if (isComponentPage) {
						window.location.href = "/skoler/?sortfield=price&sortdirection=asc";
					} else {
						loadSchools();
					}
				}, 300);
			}
		});
	}

	function initEventListeners() {
		const searchInput = document.getElementById('searchInput') || document.getElementById('school-search-input');
		if (!searchInput) {
			console.warn('No search input found');
			return;
		}

		const clearSearch = document.getElementById('clearSearch');
		const filterByMapCheckbox = document.getElementById('filter-by-map');

		let debounceTimer;
		searchInput.addEventListener('input', (e) => {
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(() => {
				const query = e.target.value.trim();
				filterSchools(query);

				if (query) {
					const filtered = getFilteredSchools();
					renderSuggestions(filtered, query);
				} else {
					hideSuggestions();
				}
			}, 300);
		});

		searchInput.addEventListener('focus', function () {
			const query = this.value.trim();
			if (query) {
				const filtered = getFilteredSchools();
				renderSuggestions(filtered, query);
			}
		});

		if (clearSearch) {
			clearSearch.addEventListener('click', () => {
				searchInput.value = '';
				selectedOffers = [];
				filterSchools('');
				hideSuggestions();
			});
		}

		const suggestionsContainer = document.querySelector('.search-box-wrap .suggestions');
		if (suggestionsContainer) {
			suggestionsContainer.addEventListener('click', function (e) {
				const link = e.target.closest('a');
				if (link) {
					if (link.classList.contains('offer-filter-item')) {
						e.preventDefault();
						const offerId = parseInt(link.dataset.offerId, 10);
						const offerName = link.dataset.offerName;
						addOfferTag(offerId, offerName);
					} else {
						hideSuggestions();
					}
				}
			});
		}

		document.addEventListener('click', function (e) {
			if (!e.target.closest('.search-box-wrap')) {
				hideSuggestions();
			}
		});

		if (filterByMapCheckbox) {
			filterByMapCheckbox.addEventListener('change', (e) => {
				filterByMapBounds = e.target.checked;
				applyFilters();
			});
		}

		document.querySelectorAll('.sort-bar a').forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				const field = link.dataset.field;
				handleSort(field);
			});
		});

		document.getElementById('skoletypeBtn')?.addEventListener('click', (e) => {
			e.preventDefault();
			toggleDropdown('skoletypeDropdown', 'skoletypeBtn');
		});

		document.getElementById('aargangBtn')?.addEventListener('click', (e) => {
			e.preventDefault();
			toggleDropdown('aargangDropdown', 'aargangBtn');
		});

		document.getElementById('flereBtn')?.addEventListener('click', (e) => {
			e.preventDefault();
			toggleDropdown('flereDropdown', 'flereBtn');
		});

		document.getElementById('mobileFilterBtn')?.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			toggleDropdown('mobileFilterDropdown', 'mobileFilterBtn');
		});

		document.addEventListener('click', (e) => {
			// Keep mobile filter open until applyMobileFilters trigger
			const isMobileDropdownOpen =
				activeDropdown === 'mobileFilterDropdown' &&
				window.matchMedia('(max-width: 768px)').matches;

			if (isMobileDropdownOpen) return;

			if (
				!e.target.closest('.filter-dropdown-wrap') &&
				!e.target.closest('.info-box-wrap')
			) {
				if (activeDropdown) {
					document.getElementById(activeDropdown).classList.remove('active');
					document.querySelector(`#${activeDropdown.replace('Dropdown', 'Btn')}`).classList.remove('active');
					activeDropdown = null;
				}
			}
		});

		document.querySelectorAll('.schooltype-checkbox').forEach(checkbox => {
			checkbox.addEventListener('change', (e) => {
				if (e.target.checked) {
					selectedSchoolTypes.push(e.target.value);
				} else {
					selectedSchoolTypes = selectedSchoolTypes.filter(t => t !== e.target.value);
				}
				syncDesktopToMobile();
				renderFilterTags();
				updateFilterCounts();
				applyFilters();
			});
		});

		document.querySelectorAll('.mobile-schooltype-checkbox').forEach(checkbox => {
			checkbox.addEventListener('change', (e) => {
				if (e.target.checked) {
					selectedSchoolTypes.push(e.target.value);
				} else {
					selectedSchoolTypes = selectedSchoolTypes.filter(t => t !== e.target.value);
				}
				syncMobileToDesktop();
				renderFilterTags();
				updateFilterCounts();
			});
		});

		document.querySelectorAll('.grade-checkbox').forEach(checkbox => {
			checkbox.addEventListener('change', (e) => {
				if (e.target.checked) {
					selectedGrades.push(e.target.value);
				} else {
					selectedGrades = selectedGrades.filter(g => g !== e.target.value);
				}
				syncDesktopToMobile();
				renderFilterTags();
				updateFilterCounts();
				applyFilters();
			});
		});

		document.querySelectorAll('.mobile-grade-checkbox').forEach(checkbox => {
			checkbox.addEventListener('change', (e) => {
				if (e.target.checked) {
					selectedGrades.push(e.target.value);
				} else {
					selectedGrades = selectedGrades.filter(g => g !== e.target.value);
				}
				syncMobileToDesktop();
				renderFilterTags();
				updateFilterCounts();
			});
		});

		attachSchoolYearListeners();

		document.querySelectorAll('.gender-radio').forEach(radio => {
			radio.addEventListener('change', (e) => {
				selectedGender = e.target.value;
				syncDesktopToMobile();
				renderFilterTags();
				updateFilterCounts();
				applyFilters();
			});
		});

		document.querySelectorAll('.mobile-gender-radio').forEach(radio => {
			radio.addEventListener('change', (e) => {
				selectedGender = e.target.value;
				syncMobileToDesktop();
				renderFilterTags();
				updateFilterCounts();
			});
		});

		document.querySelectorAll('.waitlist-checkbox').forEach(checkbox => {
			checkbox.addEventListener('change', (e) => {
				includeWaitlist = e.target.checked;
				syncDesktopToMobile();
				renderFilterTags();
				updateFilterCounts();
				applyFilters();
			});
		});

		document.querySelectorAll('.mobile-waitlist-checkbox').forEach(checkbox => {
			checkbox.addEventListener('change', (e) => {
				includeWaitlist = e.target.checked;
				syncMobileToDesktop();
				renderFilterTags();
				updateFilterCounts();
			});
		});

		document.getElementById('applyFlereFilters')?.addEventListener('click', (e) => {
			e.preventDefault();

			// Check if we're on component page (no results list)
			const isComponentPage = !document.getElementById('schoolsList');

			if (isComponentPage) {
				// Redirect to search page with filters
				const queryString = buildQueryString();
				window.location.href = queryString ? `/skoler?${queryString}` : '/skoler';
			} else {
				// Search page - scroll to results
				toggleDropdown('flereDropdown', 'flereBtn');
				scrollToResults();
			}
		});

		document.getElementById('applyMobileFilters')?.addEventListener('click', (e) => {
			e.preventDefault();

			// Check if we're on component page (no results list)
			const isComponentPage = !document.getElementById('schoolsList');

			if (isComponentPage) {
				// Redirect to search page with filters
				const queryString = buildQueryString();
				window.location.href = queryString ? `/skoler?${queryString}` : '/skoler';
			} else {
				// Search page - scroll to results
				toggleDropdown('mobileFilterDropdown', 'mobileFilterBtn');
				applyFilters();
				scrollToResults();
			}

		});

		document.getElementById('resetFlereFilters')?.addEventListener('click', (e) => {
			e.preventDefault();
			selectedRegions = [];
			selectedSchoolYear = '';
			selectedGender = '';
			includeWaitlist = false;
			selectedOtherInfo = [];
			document.querySelectorAll('.region-checkbox, .mobile-region-checkbox').forEach(cb => cb.checked = false);
			document.querySelectorAll('.schoolyear-radio[value=""], .mobile-schoolyear-radio[value=""]').forEach(rb => rb.checked = true);
			document.querySelectorAll('.gender-radio[value=""], .mobile-gender-radio[value=""]').forEach(rb => rb.checked = true);
			document.querySelectorAll('.waitlist-checkbox, .mobile-waitlist-checkbox').forEach(cb => cb.checked = false);
			document.querySelectorAll('.otherinfo-checkbox, .mobile-otherinfo-checkbox').forEach(cb => cb.checked = false);
			syncDesktopToMobile();
			syncMobileToDesktop();
			renderFilterTags();
			updateFilterCounts();
			applyFilters();
		});

		document.getElementById('resetMobileFilters')?.addEventListener('click', (e) => {
			e.preventDefault();
			clearAllFilters();
		});

		document.getElementById('clearAllFilters')?.addEventListener('click', (e) => {
			e.preventDefault();
			clearAllFilters();
		});

		document.getElementById('showSchoolsBtn')?.addEventListener('click', (e) => {
			e.preventDefault();

			// Check if we're on component page (no results list)
			const isComponentPage = !document.getElementById('schoolsList');

			if (isComponentPage) {
				// Redirect to search page with filters
				const queryString = buildQueryString();
				window.location.href = queryString ? `/skoler?${queryString}` : '/skoler';
			} else {
				// Search page - scroll to results
				scrollToResults();
			}
		});

		// Handle school-count link redirect (used in component)
		document.getElementById('school-count')?.addEventListener('click', (e) => {
			e.preventDefault();
			const queryString = buildQueryString();
			const baseUrl = e.target.closest('a').getAttribute('href') || '/skoler';
			window.location.href = queryString ? `${baseUrl}?${queryString}` : baseUrl;
		});

		// info box handler
		document.addEventListener('click', e => {
			const wrap = e.target.closest('.info-box-wrap');

			if (wrap) {

				if (e.target.closest('.open-btn')) {
					wrap.classList.toggle('active');
				}

				if (e.target.closest('.close-btn')) {
					wrap.classList.remove('active');
				}

				return;
			}

			// hide on click outside of info box
			document.querySelectorAll('.info-box-wrap.active')
				.forEach(w => w.classList.remove('active'));
		});

		document.addEventListener('click', e => {
			if (e.target.closest("a.price.noPrice")) {
				e.preventDefault();
				const overlay = document.querySelector('.overlay');
				if (overlay) {
					overlay.style.display = 'block';
				}
			}
		});

		updateFilterCounts();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			const mapElement = document.getElementById('map');
			if (mapElement) {
				initMap();
			} else {
				// No map, but still need to load schools for filters
				loadSchools();
			}
			initEventListeners();
			initPriceCalculatorModal();
		});
	} else {
		// DOM is already ready
		const mapElement = document.getElementById('map');
		if (mapElement) {
			initMap();
		} else {
			// No map, but still need to load schools for filters
			loadSchools();
		}
		initEventListeners();
		initPriceCalculatorModal();
	}
})();

